<template>
  <page>
    <div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
           <form>
            <v-card>
              <v-card-text>
                <message :messages="messages"></message>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12 md4 lg4></v-flex>
                    <v-flex xs12 md4 lg4></v-flex>
                    <v-flex xs12 md4 lg4></v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        ref="polNo"
                        v-model="form.polNo"
                        :label="labels.polNo"
                        :error-messages="errors.collect('polNo')"
                        data-vv-name="polNo"
                        :data-vv-as="labels.polNo"
                        v-validate="'required'"
                      >
                        <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="showPolicyHelpList = true" >mdi-magnify</v-icon>
                        </v-slide-x-reverse-transition>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.renCnt"
                        :label="labels.renCnt"
                        :error-messages="errors.collect('renCnt')"
                        data-vv-name="renCnt"
                        :data-vv-as="labels.renCnt"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 lg4>
                      <v-text-field
                        type="number"
                        v-model="form.endtCnt"
                        :label="labels.endtCnt"
                        :error-messages="errors.collect('endtCnt')"
                        data-vv-name="endtCnt"
                        :data-vv-as="labels.endtCnt"
                        v-validate="'required|mask_decimal:0|mask_min_value:0'"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn :loading="submitting" color="error" dark @click.prevent="doCancel"
                  >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
                >
                <v-btn :loading="submitting" color="primary" dark @click="doResend">
                  {{ labels.resend }}
                  <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </form>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- Policy HelpList -->
    <v-dialog v-model="showPolicyHelpList" width="1280px">
      <policy-help-list :apiURI="apiURI" @close="showPolicyHelpList = false" @assign-policy="assignPolicy($event)"></policy-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import PolicyHelpList from './helplist/PolicyHelpList'
// import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        endtCnt: 'Endt Count',
        resend: 'Resend',
        cancel: 'Cancel'
      },
      form: {
        polNo: '',
        renCnt: '',
        endtCnt: ''
      },
      submitting: false,
      showPolicyHelpList: false,
      loading: false,
      apiURI: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    async doInit() {
      console.log(this.$store.state.underwriting.dataTransferSettings.menu)
      this.apiURI = this.$store.state.underwriting.dataTransferSettings.menu.motorPolNoList
    },
    doCancel() {
      this.$router.push({ name: 'interface' }).catch(() => {})
    },
    doResend() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.resend()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async resend() {
      const apiURI = this.$store.state.underwriting.dataTransferSettings.menu.sendToLta
      if (apiURI) {
        this.submitting = true
        try {
          let sendForm = clone(this.form)
          await this.$http.post(apiURI, sendForm)
          this.$toast.success('Submitted Successfully.')
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolicy(data) {
      this.form.polNo = data.polNo
      this.form.renCnt = data.renCnt
      this.form.endtCnt = data.endtCnt
      this.showPolicyHelpList = false
      this.$refs.polNo.focus()
    }
  },
  created() {
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
        // getPolicyHelpList
      })
    } else {
      this.doInit()
    }
  },
  components: {
    PolicyHelpList
  },
  mixins: [MessageMixin]
}
</script>
